// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"1b0f3399","513":"e7f40448","703":"0ee0456f"}[chunkId] + ".chunk.js";
};